import { Box, Button, Card, CardBody, CardHeader, ResponsiveContext, Text } from "grommet"
import { ResponsiveGrid } from "../ResponsiveGrid"
import { CircleInformation, Hide, SettingsOption } from "grommet-icons"
import { useContext, useEffect, useState } from "react";
import { RouletteItem } from "./RouletteItem";
import { useTranslation } from "react-i18next";
import { RouletteSettingsFormContext } from "./settings/RouletteDesignSettings";

// if size if xsmall, we only 1 column
// if size if small, we only 1 column
// if size if medium, we only 2 column
// if size if large or xlarge, we 2 columns with 2/3 1/3 proportions
const columns = {
    xsmall: ["flex"],
    small: ["flex"],
    medium: ["flex", "flex"],
    large: ["flex", "flex", "flex"],
    xlarge: ["flex", "flex", "flex", "flex"]
};

// if size if xsmall, we have 2 rows
// if size if small, we have 2 rows
// if size if medium, we have 2 rows
// if size if large or xlarge, we have 1 row
const rows = {
    xsmall: ["flex"],
    small: ["flex"],
    medium: ["flex"],
    large: ["flex"],
    xlarge: ["flex"]
};

const gap = {
    xsmall: 'small',
    small: 'small',
    medium: 'small',
    large: 'small',
    xlarge: 'small'
}

const colsCount = {
    xsmall: 1,
    small: 1,
    medium: 2,
    large: 3,
    xlarge: 4
}

const getTotalRarity = (items) => {
    return items.filter(item => !item.hidden)
        .reduce((partSum, item) => partSum + item.rarity, 0)
}

export const RouletteItems = ({ items }) => {
    const { t, ready } = useTranslation('roulette'); 
    const size = useContext(ResponsiveContext);
    const [hasItems, setHasItems] = useState();
    const { handleRouletteItemSettings, handleRouletteItemHide } = useContext(RouletteSettingsFormContext);

    useEffect(() => {
        setHasItems(items.length > 0)
    }, [items])

    return (
        <>
            {!hasItems && (
                <Box align="center" justify="center" height={'300px'}>
                    <CircleInformation/>
                    <Text margin={{top: 'small'}}>{t('noItems')}</Text>
                </Box>
            )}
            {hasItems && (
                <ResponsiveGrid
                    overrideRows={rows}
                    overrideColumns={columns}
                    gap={gap[size]}
                    margin="none"
                >
                    {items.map(item => (
                        <RouletteItem 
                            key={item.id}
                            item={item} 
                            dropChance={((item.rarity / getTotalRarity(items)) * 100).toFixed(1)}
                            onSettingsClick={handleRouletteItemSettings}
                            onHideClick={handleRouletteItemHide}
                        />
                    ))}
                </ResponsiveGrid>
            )}
        </>
    )
}